@if ((loading$ | async) === false) {
  @if (lastSaveError$ | async; as error) {
    <div class="mb-4 px-4 py-2">
      <span class="text-red-500">{{ error }}</span>
    </div>
  }

  <div class="flex gap-6">
    <!-- LEFT: Section navigation -->
    <mat-nav-list class="w-[220px] shrink-0">
      @for (section of sections; track section) {
        <a
          mat-list-item
          routerLinkActive="section-link-active"
          [routerLink]="sectionRoutes[section]"
        >
          {{ sectionLabels[section] }}
        </a>
      }
    </mat-nav-list>

    <!-- RIGHT: Content area -->
    <div class="my-4 mr-4 min-w-0 flex-1">
      <!-- Section content -->
      <div class="rounded-lg border border-slate-200 bg-white p-6">
        <router-outlet />
      </div>

      <!-- Import from website & Save -->
      <div class="mt-6 flex items-center justify-between gap-4">
        <button
          mat-stroked-button
          type="button"
          data-testid="import-from-website"
          [disabled]="
            (loading$ | async) !== false || (saving$ | async) === true
          "
          (click)="importFromWebsite()"
        >
          <mat-icon>language</mat-icon>
          Import from website
        </button>
        <pt-loader-button
          type="raised"
          color="primary"
          [loading]="(saving$ | async) === true"
          (clicked)="saveAndPush()"
        >
          @if (saving$ | async) {
            Saving...
          } @else {
            Save
          }
        </pt-loader-button>
      </div>
    </div>
  </div>
} @else {
  <div class="flex flex-col items-center justify-center gap-4 p-12">
    <mat-spinner diameter="40" />
    <p>Loading AI Knowledge Base...</p>
  </div>
}
